import 'bootstrap-icons/font/bootstrap-icons.css';
import { Col, Container, Form, Row } from 'react-bootstrap';
import "./All_providers.css";
import All_providers_cards from './all_providers_cards/All_providers_cards';

const All_providers = ({
    providers = [],
    title = "ALL PROVIDERS",
    subtitle = "Select your provider & enjoy quick, seamless recharges.",
    showSearch = true,       // ✅ optional search bar
    showStateName = true,    // ✅ optional state name
    showDivider = true       // ✅ optional divider
}) => {
    return (
        <section className='providers-section'>
            <Container>
                <h2 className='providers-title'>{title}</h2>
                <p className='providers-subtitle'>{subtitle}</p>

                {/* ✅ Conditionally render search bar */}
                {showSearch && (
                    <div className='search-box'>
                        <Form.Control
                            type="text"
                            placeholder="Search Provider Name"
                            className='provider-search'
                        />
                        <i className='bi bi-search search-icon'></i>
                    </div>
                )}

                {/* ✅ Conditionally render divider */}
                {showDivider && <hr className='divider' />}

                <div className='row justify-content-center'>
                    <div className='col-md-9'>
                        {/* ✅ Conditionally render state name */}
                        {showStateName && <h5 className='state-name'>MAHARASHTRA</h5>}

                        <Row>
                            {providers.map((prov) => (
                                <Col key={prov.id} md={6} sm={12} xs={12}>
                                    <All_providers_cards
                                        logo={prov.logo}
                                        altName={prov.providerName}
                                        providerName={prov.providerName}
                                    />
                                </Col>
                            ))}
                        </Row>
                    </div>
                </div>
            </Container>
        </section>
    )
}

export default All_providers
